import IPInfo from './IPInfo';

export const models = {
  IPInfo,
};
